import * as React from 'react';
import { withRouter, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { AcceptancesPage } from './Acceptances/AcceptancesPage';
import { CreateAcceptancePage } from './Acceptances/CreateAcceptancesPage';
import { DemandsPage } from './Demands/DemandsPage';
import { DeliveryPointLayout } from './DeliveryPointLayout';

@observer
class DeliveryPointRouterComponent extends React.Component<any, any> {
    render() {
        return (
            <DeliveryPointLayout>
                <Route path='/deliverypoint/acceptances/:page?' component={AcceptancesPage} />
                <Route path='/deliverypoint/createacceptance' component={CreateAcceptancePage} />
                <Route path='/deliverypoint/demands/:page?' component={DemandsPage} />
            </DeliveryPointLayout>
        );
    }
}

const DeliveryPointRouter = withRouter(DeliveryPointRouterComponent)
export default DeliveryPointRouter;